import { render, staticRenderFns } from "./SearchFilterFieldCategory.vue?vue&type=template&id=8b0b1984&scoped=true"
import script from "./SearchFilterFieldCategory.vue?vue&type=script&lang=js"
export * from "./SearchFilterFieldCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0b1984",
  null
  
)

export default component.exports